'use strict';

angular.module('mobile-apps')
	.factory('SubscriptionMain', [
		'$rootScope',
		'MobileAppSubscription',
		'Subscription',
		'CacheDataLoad',
		function(
			$rootScope,
			MobileAppSubscription,
			Subscription,
			CacheDataLoad
		) {
			var factory = {};


			/**
			 * Returns the plan info of the current user
			 * @param forceRefresh If the data should be refreshed
			 */
			factory.getUserPlan = function (forceRefresh, cb) {
				var me = this;

				// Function which loads not cached data from database
				var getModelData = function(nothing, callback) {
					Subscription.get({
					}, function (data) {
						return callback(null, data.toJSON());
					}, function (err) {
						return callback(err);
					});
				};

				// Get data from Cache or Database depending on if data is
				// already available and if forceRefresh is set
				CacheDataLoad.getData(getModelData, 'subscription', 'user', forceRefresh,
					function(err, subscriptionInfo) {
						if (err) {
							//me.mobileApps[appId] = {};
							return cb(err);
						}

						//me.mobileApps[appId] = mobileApp;
						return cb(null, subscriptionInfo);
					}
				);
			};


			/**
			 * Returns the plan info the app is part of
			 * @param appId The id of the app to get the plan info of
			 * @param forceRefresh If the data should be refreshed
			 */
			factory.getAppPlan = function (appId, forceRefresh, cb) {
				var me = this;

				// Function which loads not cached data from database
				var getModelData = function(appId, callback) {
					MobileAppSubscription.get({
						mobileAppId: appId
					}, function (data) {
						return callback(null, data.planInfo);
					}, function (err) {
						return callback(err);
					});
				};


				// Get data from Cache or Database depending on if data is
				// already available and if forceRefresh is set
				CacheDataLoad.getData(getModelData, 'subscription', appId, forceRefresh,
					function(err, subscriptionInfo) {
						if (err) {
							//me.mobileApps[appId] = {};
							return cb(err);
						}

						//me.mobileApps[appId] = mobileApp;
						return cb(null, subscriptionInfo);
					}
				);
			};


			/**
			 * Upgrade the user to a new subscription
			 * @param planId The id of the plan to upgrade to
			 */
			factory.upgradeSubscription = function(planId, cb) {
				var me = this;

				var subscription = new Subscription ({
					planId: planId
				});

				subscription.$update(function(response) {

					// Delete the data in the cahce
					me.clearSubscriptionData();

					// Force update the plan now that it changed
					me.getUserPlan(true, function(err, currentPlan) {});

					cb(null, true);
				}, function(err) {
					cb(err);
				});
			};


			/**
			 * Returns the plans the user is allowed to choose considering his current usage
			 */
			factory.getSubscriptionPlansAllowed = function(cb) {
				Subscription.getSubscriptionPlansAllowed({},
					function (data) {
						return cb(null, data.plans);
					}, function (err) {
						return cb(err);
					}
				);
		 	};


			/**
			 * Clears all the subscription data so that it gets reloaded
			 * on the next request
			 * @returns {boolean}
			 */
			factory.clearSubscriptionData = function() {
				return CacheDataLoad.clearCache('subscription');
			};


			return factory;
		}
	]);
